import React from 'react';

/** Подпись для узла «Старт»: кампании, привязанные к этой визуальной цепочке (если есть). */
export const MailingFlowLinkedCampaignsContext = React.createContext<string | null>(null);

export function useMailingFlowLinkedCampaignsLabel(): string | null {
  return React.useContext(MailingFlowLinkedCampaignsContext);
}
